
function oneline_text(wrapper_select, child_select){
    var adj = 0.5;
    $(wrapper_select).each((idx, el)=>{
        el = $(el);
        var child = el.find(child_select);
        var init_size = flt(cstr(child.css("font-size")).replace("px", ""));

        for (var i=0; i<100; i++){
            var div_hg = el[0].scrollHeight;
            if (div_hg > el.outerHeight()){
                child.css( "font-size",init_size-=adj);
            }else{
                break;
            }
        }
    })
};

window.oneline_text = oneline_text;